module.exports = require('./DepBankAcquisitionMergerNewFilingView');
